import React, { useRef, useState, useEffect } from "react";
import Tooltip from '@mui/material/Tooltip';

const Send = (props) => {
  const {
    handleAddMessage,
    handleLoadClue,
    handleAddMessageKeyDown,
    loadedClue,
    hintsUsed,
    //avgCluePerMinute,
    addedMinutes,
    togglePlayAudioClue,
  } = props;

  const textArea = useRef()
  const [loaded, setLoaded] = useState(loadedClue)
  useEffect(() => {

    // Clear text box when game resets
    if (!loadedClue) textArea.current.value = '';
    setLoaded(loadedClue)
  }, [loadedClue])

  const handleMessage = () => {
    handleAddMessage(loadedClue)
    textArea.current.value = '';
  }

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 && e.keyCode <= 90 && !e.shiftKey){
      e.preventDefault()
      handleAddMessage(loadedClue)
      //handleAddMessageKeyDown(e)
      textArea.current.value = '';
    }
    // handleAddMessageKeyDown(e)
    // textArea.current.value = '';
  }


  //console.log(loadedClue)
  return (
    <div style={{position:'absolute'}}>
    <div className="controlsBox card">
      <div className="pd-10" style={{ paddingTop: "10px" }}>
        <textarea
          ref={textArea}
          type="text"
          className="form-control   align-self-center bd-0"
          placeholder="Type a message here..."
          style={{
            resize: "none",
            height: "80px",
            fontSize: "16px",
            fontWeight: "500",
            border: loadedClue.message ? '2px solid rgb(1, 104, 250)' : '1px solid black',
            transition:'0.2s'
          }}
          value={loadedClue.message}
          onChange={handleLoadClue.bind(this)}
          onKeyDown={(e)=> handleKeyDown(e)}
        ></textarea>

        <div className="row" style={{ padding: "10px 15px" }}>
          <div
            className="col-6"
            style={{ fontSize: "20px", paddingLeft: "5px" }}
          ></div>

          <div
            className="col-12"
            style={{ textAlign: "right", paddingRight: "5px" }}
          >

            <div style={{float:'left', display:'flex', marginLeft:'-10px'}}>
            <Tooltip title="Messages Sent" placement="bottom">
                <p
                  className="text-muted"
                  style={{ paddingRight: "20px", marginBottom: "0" }}
                >
                  <i
                    className="icon ion-ios-text"
                    style={{marginRight: "5px" }}
                  ></i>

                  {hintsUsed}
                </p>
              </Tooltip>

              <Tooltip title="Time Adjusted" placement="bottom">
                <p className="text-muted" style={{ marginBottom: "0" }}>
                <i
                    className="icon ion-ios-timer"
                    style={{marginRight: "5px" }}
                  ></i>
                  {addedMinutes} min
              </p>
              </Tooltip>
            </div>



            <button
              onClick={() => togglePlayAudioClue("alert-button")}
              type="button"
              className="btn btn-xs btn-outline-light"
              style={{ marginRight: "10px", fontSize: "14px" }}
            >
              <i
                className="icon ion-md-volume-high"
                style={{ marginRight: "10px" }}
              ></i>
              Alert Tone
            </button>

            {loadedClue.message ? (
              <button
                type="button"
                className="btn btn-xs btn-purple"
                style={{ fontSize: "14px", height:'25px' }}
                onClick={() => handleMessage()}
              >
                <i
                  className="icon ion-md-send"
                  style={{ color: "white", marginRight: "10px" }}
                ></i>
               Send
              </button>
            ) : (
              <button
                type="button"
                disabled
                className="btn btn-xs btn-purple disabled"
                style={{ fontSize: "14px", height:'25px' }}
                onClick={() => handleAddMessage(loadedClue)}
              >
                <i
                  className="icon ion-md-send"
                  style={{ color: "white", marginRight: "10px" }}
                ></i>
                Send
              </button>
            )}
          </div>
        </div>
      </div>
    </div>

    {loadedClue.message ? (
      <div style={{position:'absolute', bottom:'0', right:'20px', opacity:'0.5'}}>
        <small style={{marginRight:'20px'}}><b>Return</b> to send</small>
        <small><b>Shift + Return</b> to add a new line</small>
      </div>
    ) : null}

    </div>
  );
};

export default Send;
